/* app/js/src/components/common/sound-icon/sound-icon.component.scss */
/*# sourceMappingURL=sound-icon.component.css.map */
